import { getConfigs } from "@/app/services/configService/getConfigs";
import { useQuery } from "@tanstack/react-query";

export const useConfigsPage = () => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ["configsPage"],
    queryFn: () => getConfigs(),
  });

  return {
    refetch,
    isLoading,
    configs: data,
  };
};
